import lazyframe from "lazyframe";

function pauseYoutubeVideo(obj) {
    let command = {
        "event": "command",
        "func": "pauseVideo"
    };
    obj.contentWindow.postMessage(JSON.stringify(command), '*');
}

function playYoutubeVideo(obj) {
    let command = {
        "event": "command",
        "func": "playVideo"
    };
    obj.contentWindow.postMessage(JSON.stringify(command), '*');
}
function pauseVimeoVideo(obj) {
    let command = {
        "method": "pause",
        "value": 1
    };
    obj.contentWindow.postMessage(JSON.stringify(command), '*');
}

function playVimeoVideo(obj) {
    let command = {
        "method": "play",
        "value" : 1
    };
    obj.contentWindow.postMessage(JSON.stringify(command), '*');
}
export function pauseSliderVideos (slider) {
    let slides = slider.el.querySelectorAll('.swiper-slide');
    for (let s in slides) {
        if(isNaN(s)) continue;
        if(slides[s].querySelector('video') !== null) slides[s].querySelector('video').pause();
        else if(slides[s].querySelector('iframe.yt-player') !== null) pauseYoutubeVideo(slides[s].querySelector('iframe.yt-player'));
        else if(slides[s].querySelector('iframe.vi-player') !== null) pauseVimeoVideo(slides[s].querySelector('iframe.vi-player'));
    }
}

export function playSliderVideos(slider) {
    let activeSlide = slider.el.querySelectorAll('.swiper-slide')[slider.activeIndex];
    if(activeSlide.querySelector('video') !== null) activeSlide.querySelector('video').play();
    else if(activeSlide.querySelector('iframe.yt-player') !== null) playYoutubeVideo(activeSlide.querySelector('iframe.yt-player'));
    else if(activeSlide.querySelector('iframe.vi-player') !== null) playVimeoVideo(activeSlide.querySelector('iframe.vi-player'));
}

export function showFieldDownload(fieldContainer, checkName) {
    fieldContainer.classList.remove('d-none');
    let input = fieldContainer.querySelector('input'),
        select = fieldContainer.querySelector('select'),
        field = (input !== null) ? input : select;
    if(fieldContainer.classList.contains('confirmation-required-both') || fieldContainer.classList.contains(`${checkName}-required`)) {
        field.setAttribute('data-validation','required');
        field.setAttribute('data-validation-event','blur');
    } else {
        field.removeAttribute('data-validation');
        field.removeAttribute('data-validation-event');
    }
}

export function hideFieldDownload(fieldContainer, opossed) {
    let input = fieldContainer.querySelector('input'),
        select = fieldContainer.querySelector('select'),
        field = (input !== null) ? input : select,
        opossedChecked = (document.querySelector(`[name="${opossed}"]`).checked);

    if(!opossedChecked || !fieldContainer.classList.contains(opossed)) {
        fieldContainer.classList.add('d-none');
        field.removeAttribute('data-validation');
        field.removeAttribute('data-validation-event');
    }
}

export function showHideDownloadHelpLanguage(selectedLanguage, helpLanguage) {
    console.log(selectedLanguage)
    if (selectedLanguage === 'en') helpLanguage.classList.remove('d-none');
    else helpLanguage.classList.add('d-none');
}